const cashierRoutes = [
  {
    path: '/cashier',
    name: 'Cashier',
    meta: {
      index: 100
    },
    component: () => import('@/views/cashier/Index.vue')
  },
  {
    path: '/pay-result',
    name: 'PayResult',
    meta: {
      index: 101
    },
    component: () => import('@/views/cashier/PayResult.vue')
  }
]
export default cashierRoutes
